import { IUseHeaderResponse } from "@/layouts/general/hooks/useHeader";
import { Path } from "@/navigations/routes";
import Link from "next/link";
import React, { useState } from "react";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
  SheetClose,
} from "@sendsprint/ui-react/shadcn/sheet";
import HamburgerIcon from "@/assets/svgs/hamburger.svg";
import Box from "@sendsprint/ui-react/components/box";
import Container from "@sendsprint/ui-react/components/container";
import Logo from "@/assets/svgs/logo-full-green.svg";
import CloseOutline from "@sendsprint/icons/svgs/CloseOutline";
import ButtonLinkNext from "@sendsprint/ui-react/components/buttonLinkNext";

interface Props {
  headerLogic: IUseHeaderResponse;
}

const MobileNavigation = ({ headerLogic }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const { loginLink, registerLink, handleClearCampaignId } = headerLogic;

  const handleOpen = (arg: boolean) => {
    setIsOpen(arg);
  };

  return (
    <div className="ss:lg:hidden">
      <Sheet open={isOpen} onOpenChange={handleOpen}>
        <SheetTrigger asChild>
          <button className="ss:flex ss:w-10 ss:h-10 ss:bg-white ss:items-center ss:justify-center ss:relative ss:rounded-full ss:shadow">
            <HamburgerIcon className="ss:w-5 ss:h-5" />
          </button>
        </SheetTrigger>
        <SheetContent
          side="top"
          showCloseButton={false}
          className="data-[side=bottom]:max-h-[50vh] ss:overflow-y-auto ss:rounded-b-2xl data-[side=top]:max-h-[50vh]"
        >
          <Container>
            <SheetHeader className="ss:flex ss:py-4 ss:flex-row ss:items-center ss:justify-between">
              <div className="ss:flex-1">
                <SheetTitle>
                  <Logo className="ss:h-10 ss:w-32 ss:md:w-44 ss:xl:w-56 ss:md:h-10" />
                </SheetTitle>
                <SheetDescription></SheetDescription>
              </div>
              <SheetClose className="ss:flex ss:w-10 ss:h-10 ss:bg-white ss:items-center ss:justify-center ss:relative ss:rounded-full ss:shadow">
                <CloseOutline />
              </SheetClose>
            </SheetHeader>
            <div className="no-scrollbar ss:overflow-y-auto ss:pb-16">
              <div className="ss:flex ss:flex-col ss:items-center">
                <Link
                  onClick={() => handleOpen(false)}
                  className="ss:p-3 ss:my-2 ss:text-center ss:block ss:font-bold"
                  href={Path.AboutUs}
                >
                  About us
                </Link>
                <Link
                  onClick={() => handleOpen(false)}
                  className="ss:p-3 ss:my-2 ss:text-center ss:block ss:font-bold"
                  href={`${Path.Home}#faq`}
                >
                  FAQs
                </Link>
                <Link
                  onClick={() => {
                    handleOpen(false);
                    handleClearCampaignId();
                  }}
                  className="ss:p-3 ss:my-2 ss:text-center ss:block ss:font-bold"
                  href={loginLink}
                  target="_blank"
                >
                  Login
                </Link>
                <Box className="ss:w-full ss:px-3">
                  <ButtonLinkNext
                    onClick={() => {
                      handleOpen(false);
                      handleClearCampaignId();
                    }}
                    href={registerLink}
                    label="Register"
                    fullWidth
                  />
                </Box>
              </div>
            </div>
          </Container>
        </SheetContent>
      </Sheet>
    </div>
  );
};

export default MobileNavigation;
